/**
 * Self-hosted webfonts — requirement 6.7.
 *
 * Both faces come from fontsource, which is a package of font *files*; the `@font-face` rules are
 * generated here rather than imported from fontsource's own stylesheets for one reason. A preload
 * only helps if the URL it names is the URL the browser then requests, and fontsource's CSS points at
 * paths that the bundler hashes. Declaring the rules here, against the stable `/fonts/*` URLs that
 * `staticAssets` in `@apuestapr/config` serves, makes the preload tag and the `src` descriptor name
 * the same file.
 *
 * Everything is served from the app's own origin. No request leaves for a font CDN, which is the
 * requirement's first half; `font-display: swap` is the second, so text is visible in a fallback face
 * from the first paint rather than invisible until the download finishes.
 *
 * Latin subset only. Spanish's accented characters and `ñ` are all inside it, and adding
 * `latin-ext` would roughly double the bytes for glyph coverage this product has no copy in.
 */
const inter = (weight, preload = false) => ({
    specifier: `@fontsource/inter/files/inter-latin-${String(weight)}-normal.woff2`,
    file: `inter-latin-${String(weight)}-normal.woff2`,
    family: 'Inter',
    weight,
    preload,
});
const poppins = (weight, preload = false) => ({
    specifier: `@fontsource/poppins/files/poppins-latin-${String(weight)}-normal.woff2`,
    file: `poppins-latin-${String(weight)}-normal.woff2`,
    family: 'Poppins',
    weight,
    preload,
});
export const fontFiles = [
    inter(400, true),
    inter(500),
    inter(600),
    poppins(600, true),
    poppins(700),
];
/** URL prefix `staticAssets` mounts the font files at. Stable, so `index.html` can name it. */
export const fontsUrlPrefix = '/fonts';
/** `<link rel="preload">` targets, in the shape the Vite plugin takes. */
export const preloadedFonts = fontFiles
    .filter((font) => font.preload)
    .map((font) => ({
    href: `${fontsUrlPrefix}/${font.file}`,
    as: 'font',
    type: 'font/woff2',
}));
const fontFace = (font) => [
    '@font-face {',
    `  font-family: '${font.family}';`,
    '  font-style: normal;',
    `  font-weight: ${String(font.weight)};`,
    '  font-display: swap;',
    `  src: url('${fontsUrlPrefix}/${font.file}') format('woff2');`,
    '}',
].join('\n');
export const renderFontsCss = () => [
    '/*',
    ' * Generated by @apuestapr/ui — do not edit.',
    ' * Source: packages/ui/src/styles/fonts.ts, emitted by packages/ui/src/styles/emit.cli.ts.',
    ' */',
    '',
    fontFiles.map(fontFace).join('\n\n'),
    '',
].join('\n');
//# sourceMappingURL=fonts.js.map